/** Invalidating a report rejects any response from an older observation/filter. */
export class ReportRequestGate {
  private epoch=0;private sequence=new Map<string,number>();
  invalidate(){this.epoch++;}
  begin(key:string){const n=(this.sequence.get(key)??0)+1;this.sequence.set(key,n);const epoch=this.epoch;return ()=>epoch===this.epoch&&this.sequence.get(key)===n;}
}
/** Collapse bursts of account publications into one report invalidation. */
export function coalesceRefresh(refresh:()=>void,delay=250) {
  let timer:ReturnType<typeof setTimeout>|undefined;
  return {request(){if(timer!==undefined)return;timer=setTimeout(()=>{timer=undefined;refresh();},delay);},cancel(){if(timer!==undefined)clearTimeout(timer);timer=undefined;}};
}
